import React, { useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import usePayrollApi from "../../../services/payroll/payrollApi";
import moment from "moment";
import { Button } from "react-bootstrap";
import AddBenefit from "./addBenefit";
import { useQuery } from "@tanstack/react-query";
import BasicTable from "../../../components/UiComponent/customTable";
import CustomModal from "../../../components/UiComponent/Modal";
const Benefit = () => {
  const { t } = useTranslation();
  const { get_benefit_list } = usePayrollApi();
  const [showModal, setShowModal] = useState(false);
  const [benefitId, setBenefitId] = useState();
  const [modal_title, setModalTitle] = useState();
  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  const handleButtonSubmit = () => {
    handleCloseModal();
  };
  const BenefitQuery = useQuery(["benefit_list"], () => get_benefit_list());
  const benefitData = useMemo(() => {
    return BenefitQuery.data?.data?.benefits || [];
  }, [BenefitQuery.data]);
  if (BenefitQuery.isLoading) {
    return <div>Loading...</div>;
  }
  if (BenefitQuery.isError) {
    return <div>Error: {BenefitQuery.error.message}</div>;
  }
  const openUpdateBenefitModal = (event, id) => {
    event.preventDefault();
    handleShowModal();
    setBenefitId(id);
    setModalTitle("update_benefit_title");
  };

  const benefitColumns = [
    {
      header: "grade",
      accessorKey: "grade_id",
    },
    {
      header: "Benefit",
      accessorKey: "benefit_name",
      cell: (row) => (
        <div>
          <p className="m-0 text-secondary small">
            {row.row.original.benefit_name}
          </p>
          <p className="m-0 text-secondary small">
            {row.row.original.is_taxable ? "taxable" : "non taxable"}
          </p>
        </div>
      ),
    },
    {
      header: "amount",
      accessorKey: "amount",
      cell: (row) => (
        <div>
          <p>
            {row.row.original.amount}
            <i className="m-0 text-secondary small">
              {row.row.original.is_percentage ? " % " : " "}
            </i>
          </p>
        </div>
      ),
    },
    {
      header: "branch",
      accessorKey: "branch.name",
    },
    {
      header: "from_date",
      accessor: "from_date",
      accessorFn: (row) => `${moment(row.from_date).format("YYYY-MM-DD")} `,
    },
    {
      header: "to_date",
      accessor: "to_date",
      accessorFn: (row) => `${moment(row.to_date).format("YYYY-MM-DD")}`,
    },

    {
      header: "action",
      accessor: "id",
      cell: (row) => (
        <Button
          variant="btn btn-info btn-sm"
          onClick={(e) => openUpdateBenefitModal(e, row.row.original)}
        >
          {t("update_benefit")}
        </Button>
      ),
    },
  ];

  const openAddBenefitModal = (event) => {
    event.preventDefault();
    handleShowModal();
    setBenefitId();
    setModalTitle("add_new_benefit");
  };
  return (
    <div>
      <BasicTable
        data={benefitData}
        columns={benefitColumns}
        title={`benefit_list`}
        actionButton={
          <Button
            variant="btn btn-info btn-sm"
            onClick={(e) => openAddBenefitModal(e)}
          >
            {t("add_benefit")}
          </Button>
        }
      />

      <CustomModal
        show={showModal}
        title={modal_title}
        onHide={handleCloseModal}
        centered={true}
        backdrop="static"
        keyboard={false}
        content={
          <AddBenefit
            closeModal={handleButtonSubmit}
            initialValues={benefitId}
          />
        }
      />
    </div>
  );
};
export default Benefit;
